import {defineAbilityConfig} from '../system/defineAbilityConfig';
import {ENTITLEMENT_KEYS} from '@packages/domains/billing/constants';

export const canAccessActivityLog = defineAbilityConfig({
  userTypes: {
    authorizedInDesigner: true,
  },
  features: {activityLog: true},
  entitlements: [ENTITLEMENT_KEYS.ALLOW_SITE_ACTIVITY_LOG],
} as const);

export const canSeeActivityLogIcon = defineAbilityConfig([
  {
    userTypes: {
      authorizedInDesigner: true,
      unauthorized: true,
    },
    workflows: {canvas: true},
    entitlements: [ENTITLEMENT_KEYS.ALLOW_SITE_ACTIVITY_LOG],
  },
] as const);
